import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Box, IconBox, Icons, Text, Theme } from 'baukasten';

import WorkpathLogo from 'components/WorkpathLogo';
import Link from 'components/Link';

import messages from '../messages';

const IconWrapper = styled(IconBox)`
  display: inline-block;
  vertical-align: middle;
`;

const StyledImage = styled.img`
  max-width: 100%;
  max-height: min(350px, 50vh);
`;

export const SecondaryContent = () => {
  const { formatMessage, locale } = useIntl();

  const getCTAUrl = () => {
    if (locale === 'de') {
      return 'https://workpath.zendesk.com/hc/de/articles/22066368167708-Workpath-KI-Features-Vollst%C3%A4ndige-%C3%9Cbersicht';
    }
    return 'https://workpath.zendesk.com/hc/en-us/articles/22066368167708-Workpath-AI-Features-Complete-Overview';
  };

  return (
    <Box
      pl={16}
      pr={16}
      pt={12}
      pb={12}
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      style={{ flexGrow: 1 }}
    >
      <Box mb={8}>
        <WorkpathLogo color="white" />
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        style={{ flexGrow: 1 }}
      >
        <Text as="h2" color="white" fontSize={32}>
          {formatMessage(messages.secondaryContentTitle)}
        </Text>

        <Box mt={8} display="flex" justifyContent="center">
          <StyledImage
            src="https://workpath-platform-static.s3.eu-central-1.amazonaws.com/product-marketing/feature-promo-ai-agent-2025.png"
            alt="AI Companion feature illustration"
          />
        </Box>

        <Text color="white" fontSize={16} mt={8}>
          {formatMessage(messages.secondaryContentDescription)}
        </Text>

        <Link to={getCTAUrl()} target="_blank" color={Theme.getColor('yellow')}>
          <Text color="yellow" fontSize={16} fontWeight="bold" mt={4}>
            {formatMessage(messages.secondaryContentCTA)}
            <IconWrapper>
              <Icons.ExternalLink color="yellow" />
            </IconWrapper>
          </Text>
        </Link>
      </Box>
    </Box>
  );
};
